// Inline SVGs for the 2FA setup page (ACA-250 §2.2-§2.4). Same pattern as onboarding/onboardingIcons.tsx.

export function EnvelopeIcon() {
  return (
    <svg aria-hidden="true" fill="none" height="28" viewBox="0 0 28 28" width="28">
      <rect height="15" rx="2" stroke="currentColor" strokeWidth="1.5" width="21" x="3.5" y="6.5" />
      <path
        d="M4.5 7.5 14 15l9.5-7.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function CircleAlertIcon() {
  return (
    <svg aria-hidden="true" fill="none" height="15" viewBox="0 0 15 15" width="15">
      <circle cx="7.5" cy="7.5" r="6.75" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7.5 4.5v4" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
      <circle cx="7.5" cy="10.5" fill="currentColor" r="0.75" />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg aria-hidden="true" fill="none" height="26" viewBox="0 0 26 26" width="26">
      <path
        d="M6 13.5 11 18.5 20 8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
      />
    </svg>
  );
}
